import React, { memo } from 'react'

import {
  AIGeneratedGradientFilled, BrushAI, Button, Download, Icon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import { NOOP } from 'Utils/stableDefaults'

const editIcon = <Icon svgComponent={BrushAI} size={iconSize} notSpaced />
const downloadIcon = <Icon svgComponent={Download} size={iconSize} notSpaced />
const generateIcon = <Icon svgComponent={AIGeneratedGradientFilled} size={iconSize} notSpaced />

// Edit / Download / Generate 3D under the expanded image. The handlers are wired by the
// host and are no-ops until their flows ship.
function Actions({
  title,
  onEdit = NOOP,
  onDownload = NOOP,
  onGenerate3d = NOOP,
}) {
  const t = useTranslation()

  return (
    <div className="image-gallery-modal__actions">
      <Button
        type="secondary"
        size="small"
        variant="with-icon"
        actionType="button"
        icon={editIcon}
        customClass="image-gallery-modal__action"
        onClick={onEdit}
        aria-label={t('imageGallery.card.edit', { title })}
      >
        {t('imageGallery.modal.edit')}
      </Button>
      <Button
        type="secondary"
        size="small"
        variant="with-icon"
        actionType="button"
        icon={downloadIcon}
        customClass="image-gallery-modal__action image-gallery-modal__action--download"
        onClick={onDownload}
        aria-label={t('imageGallery.card.download', { title })}
      >
        {t('imageGallery.modal.download')}
      </Button>
      <Button
        type="secondary"
        size="small"
        variant="with-icon"
        actionType="button"
        icon={generateIcon}
        customClass="image-gallery-modal__action image-gallery-modal__action--ai"
        onClick={onGenerate3d}
        aria-label={t('imageGallery.card.generate3dFor', { title })}
      >
        {t('imageGallery.card.generate3d')}
      </Button>
    </div>
  )
}

Actions.propTypes = {
  title: string.isRequired,
  onEdit: func,
  onDownload: func,
  onGenerate3d: func,
}

export default memo(Actions)
